var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"Knob_track",class:{ Knob_track_on: _vm.value },attrs:{"id":`:rgi:`,"aria-label":"Example knob","role":"switch","type":"button","aria-checked":_vm.value},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('div',{staticClass:"Knob_knob",class:{ Knob_knob_on: _vm.value }})])
}
var staticRenderFns = []

export { render, staticRenderFns }